import { Component, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { FormSessionCanDeactivate, PatientService, UserService } from '../../shared';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-question',
  templateUrl: './questions.component.html',
  styleUrls: ['./questions.component.css']
})
export class QuestionComponent extends FormSessionCanDeactivate {
  patid: any;
  welcome: any;
  modalRef: any;
  resdata: any;
  question: any = [];
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm', backdrop: 'static' });
    this.movable()
  }
  constructor(
    private patientservice: PatientService,
    private routerr: ActivatedRoute,
    private modalService: BsModalService,
    private nav: Router,
    private translate: TranslateService,
    private Userservice: UserService
  ) {
    super();
    this.translate.setDefaultLang(Userservice.defaultLang);
  }

  ngOnInit() {


    // this.routerr.params.subscribe( params => {
    //   this.patid =params
    //   this.patientservice.changeNav(params.id)
    //  this.patid=params.id

    // } );

    this.patientservice
      .getquestions()
      .subscribe(
        data => {

          //////console.log(data);
          if (data) {

            this.question = data;
          }
          else {


          }
        }
      );


  }
  addpat(result) {
    //////console.log(this.patid);
    this.patientservice
      .getwelcome(this.patid, '')
      .subscribe(
        data => {

          //////console.log(data);
          if (data.userInfo.status == "success") {

            this.nav.navigate([`/createnewpass/${this.patid}`])
          }
          else {
            this.resdata = "You have already registered";
            this.modalRef = this.modalService.show(result, { class: 'modal-sm', backdrop: 'static' });
            this.movable()
          }
        }
      );

  }
  movable() {
    $(function () {
      let modalContent: any = $('.modal-content');
      let modalHeader = $('.modal-header');
      modalHeader.addClass('cursor-all-scroll');
      modalContent.draggable({
        handle: '.modal-header'
      });
    });
  }
}
